import WithArrow from 'components/WithArrow';
import BodyText from 'components/text/BodyText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ExportDropdownTrigger: FunctionComponent<Props> = ({
    className = '',
    isDisabled = false,
    testId = TEST_ID
}) => {
    const { EXPORT } = useTranslation();

    const disabledClass = isDisabled ? styles.exportDropdownTriggerDisabled : '';

    return (
        <WithArrow
            className={`${className} ${disabledClass} ${styles.exportDropdownTrigger}`}
            testId={testId}>
            <BodyText text={EXPORT} />
        </WithArrow>
    );
};

export default ExportDropdownTrigger;
